import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { addQuery, removeQuery } from 'Helpers/Query';
import MetaQueryForm from 'Components/UI/Meta/MetaQueryForm';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import {
  setRefreshLink,
  refreshEscalatedHouseholds,
  refreshDetails,
} from './ClientExperienceSavesContext';

const styles = () => ({
  root: {
  },
});

function SaveFilters({
  collection, dispatch,
}) {
  const {
    logEvent,
  } = useEventTrackingLogEvent({
    nodeName: 'Client Experience Saves',
  });

  const onApplyFilters = (refreshLink) => {
    logEvent('Clicked Apply Filters Button');
    setRefreshLink(refreshLink, dispatch);
    addQuery({ link: refreshLink });
    removeQuery('selected');
    removeQuery('householdId');
    refreshDetails(refreshLink, dispatch);
    refreshEscalatedHouseholds(refreshLink, dispatch);
  };

  const availableFilters = [
    {
      name: 'householdId',
      query: 'getEscalatedHouseholds',
      prompt: 'Household ID',
    },
    {
      name: 'leadPlannerAgentId',
      query: 'getEscalatedHouseholds',
      prompt: 'Lead Planner',
    },
    {
      name: 'agentId',
      query: 'getEscalatedHouseholds',
      prompt: 'Save Agent',
    },
    {
      name: 'escalationDate',
      query: 'getEscalatedHouseholds',
      prompt: 'Escalation Date',
    },
  ];

  return (
    collection && (
    <MetaQueryForm
      collection={collection}
      onSubmit={onApplyFilters}
      availableFilters={availableFilters}
    />
    )
  );
}

export default withStyles(styles)(SaveFilters);
